import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=33c63d90&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=33c63d90&scoped=true&lang=css&"
import style1 from "./Slider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c63d90",
  null
  
)

export default component.exports